interface Props {
  measureCount: number;
  maxMeasures?: number;
  onMeasureCountChange: (count: number) => void;
  onAddMeasure: () => void;
  onOpenLibrary?: () => void;
  libraryCount?: number;
}

export function MelodyMeasureBar({
  measureCount,
  maxMeasures = 8,
  onMeasureCountChange,
  onAddMeasure,
  onOpenLibrary,
  libraryCount = 0,
}: Props) {
  return (
    <div className="melody-measure-bar">
      <label className="melody-measure-bar__field">
        <span className="melody-measure-bar__label">Compases</span>
        <select
          className="melody-measure-bar__select"
          value={measureCount}
          onChange={(e) => onMeasureCountChange(Number(e.target.value))}
          aria-label="Cantidad de compases"
        >
          {Array.from({ length: maxMeasures }, (_, i) => i + 1).map((n) => (
            <option key={n} value={n}>
              {n}
            </option>
          ))}
        </select>
      </label>
      <button
        type="button"
        className="btn btn-secondary melody-measure-bar__add"
        onClick={onAddMeasure}
        disabled={measureCount >= maxMeasures}
        title="Añadir compás"
      >
        + Compás
      </button>
      {onOpenLibrary && (
        <button
          type="button"
          className="btn btn-secondary melody-measure-bar__library"
          onClick={onOpenLibrary}
          title="Biblioteca de patrones"
        >
          📚 Biblioteca{libraryCount > 0 ? ` (${libraryCount})` : ''}
        </button>
      )}
    </div>
  );
}
